module.exports = __webpack_public_path__ + "static/img/enewm.41a1700f.jpg";